import React, { createContext, useState } from "react";
import { Navigate } from "react-router-dom";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const storedUser = JSON.parse(localStorage.getItem("i_ems_employee_profile") || "null");
  const storedToken = localStorage.getItem("i_ems_employee_token");

  const [isLoggedIn, setIsLoggedIn] = useState(!!storedToken);
  const [session, setSession] = useState({ token: storedToken });
  const [userProfile, setUserProfile] = useState(storedUser || null);

  const login = () => {
    setIsLoggedIn(true);
    return <Navigate to="/" />;
  };

  const logout = () => {
    localStorage.removeItem("i_ems_employee_token");
    localStorage.removeItem("i_ems_employee_profile");
    window.location.href = `${window.location.origin}/login`;
    return <Navigate to="/login" />;
  };

  return (
    <AuthContext.Provider
      value={{ isLoggedIn, setIsLoggedIn, session, setSession, userProfile, setUserProfile, login, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
};
